export default () => {
  const model = {
    header: [
      { label: '业务区', prop: 'businessName' },
      {
        label: '小计',
        children: [
          { label: '数量', prop: 'subtotalAmount' },
          { label: '预算', prop: 'subtotalBudget' }
        ]
      },
      {
        label: '达产',
        children: [
          { label: '数量', prop: 'productionAmount' },
          { label: '预算', prop: 'productionBudget' }
        ]
      },
      {
        label: '正在支撑',
        children: [
          { label: '数量', prop: 'normalAmount' },
          { label: '预算', prop: 'normalBudget' }
        ]
      },
      {
        label: '1个月',
        children: [
          { label: '数量', prop: 'oneMonthAmount' },
          { label: '预算', prop: 'oneMonthBudget' }
        ]
      },
      {
        label: '3个月',
        children: [
          { label: '数量', prop: 'threeMonthAmount' },
          { label: '预算', prop: 'threeMonthBudget' }
        ]
      },
      {
        label: '6个月及以上',
        children: [
          { label: '数量', prop: 'sixMonthAmount' },
          { label: '预算', prop: 'sixMonthBudget' }
        ]
      },
      // {
      //   label: '半年以上',
      //   children: [
      //     { label: '数量', prop: 'halfOfAYearAmount' },
      //     { label: '预算', prop: 'halfOfAYearBudget' }
      //   ]
      // },
      {
        label: '暂停失效',
        children: [
          { label: '数量', prop: 'failAmount' },
          { label: '预算', prop: 'failBudget' }
        ]
      }
    ],
    data: []
  };
  return model;
};
